module.exports = __webpack_public_path__ + "img/features-store.8dc588f4.svg";